import { Spacer, TextTitle } from '@pypestream/design-system';
import { AgentRouting } from '@pypestream/api-services/urql';
import { TranslationComponent } from '@pypestream/translations';

import { StudioPageProps } from '../hooks/use-pro-studio-routes';
import { WithLoadingState } from '../router';
import {
  BrandingOptionsFormValues,
  ChannelSettingsForm,
  SizingOptionsFormValues,
} from '../components';
import { AgentSupportPlatformFormValues } from '../components/channel-settings-form/channel-settings-form';

type ChannelCreatePageProps = StudioPageProps;

const customStyling = {
  buttonColor: '#454545',
  textColor: '#FFFFFF',
  brandMomentUrl: '',
};

const brandingFormDefaultValues: BrandingOptionsFormValues = {
  widgetStyleColor: '#007BFF',
  widgetStyleTextColor: '#FFFFFF',
  agentBubbleColor: '#DEE8F5',
  agentBubbleTextColor: '#000000',
  userBubbleColor: '#113260',
  userBubbleTextColor: '#FFFFFF',
  name: 'Web Conversational Interface',
  logo: '',
  bannerUrl: '',
  customPypeCss: '',
  ...customStyling,
};

const sizingFormDefaultValues: SizingOptionsFormValues = {
  widgetWidth: 500,
  widgetHeight: 800,
  shouldLockRatio: false,
};

const agentSupportPlatformFormDefaultValues: AgentSupportPlatformFormValues = {
  accountId: '',
  inboxId: '',
  agentRouting: AgentRouting.Pypestream,
  botRetry: {
    attempts: 3,
    timeout: 35000,
  },
};

const ChannelCreatePage: React.FC<ChannelCreatePageProps> = () => {
  return (
    <>
      <TextTitle test-id="ps-create-channel-title" size="small">
        <TranslationComponent i18nKey="pro-studio/channel-details:title.create">
          Create Channel
        </TranslationComponent>
      </TextTitle>
      <Spacer size="large" />
      <ChannelSettingsForm
        type="create"
        values={{
          detailsFormValues: {
            name: '',
            env: 'sandbox',
            pypeId: '',
            streamId: '',
          },
          brandingFormValues: brandingFormDefaultValues,
          sizingFormValues: sizingFormDefaultValues,
          agentSupportPlatformFormValues: agentSupportPlatformFormDefaultValues,
        }}
      />
    </>
  );
};

export const ChannelCreate = WithLoadingState(ChannelCreatePage);
